import React from 'react'
import img from '../../assets/company/Profile_M.png'
import pratap from '../../assets/company/Prathap.png'
import Bhargavi from '../../assets/company/Bhargavi.png'
import shamal from '../../assets/company/Shamal.png'
import Srinivas from '../../assets/company/Srinvas.png'
import dinesh from '../../assets/company/Dinesh.png'
import MowzzLogo from '../../assets/company/MowzzLogo.png'

const Team = () => {

  const team = [
    {
      name: "Bhargavi",
      role: "OPERATIONS",
      image: Bhargavi,
      isLogo: false
    },
    {
      name: "Pratap",
      role: "CREATIVE",
      image: pratap,
      isLogo: false
    },
    {
      name: "Shyamal",
      role: "PRODUCTION EXPERT",
      image: shamal,
      isLogo: false
    },
  ]

  const partner = [
    {
      name: "Srinivas Varaganti",
      role: "BLUEDOOR PARTNER",
      image: Srinivas,
      isLogo: false
    },
    {
      name: "Dinesh",
      role: "BLUEDOOR PARTNER",
      image: dinesh,
      isLogo: false
    },
    {
      name: "Mouzz Audio",
      role: "BLUEDOOR PARTNER",
      image: MowzzLogo,
      isLogo: true
    },
  ]

  return (
    <div className='bg-company-teams h-fit min-h-[60vh] py-16 w-full bg-cover bg-center flex flex-col gap-12 justify-center items-center text-[#fff]'> 
        <div className='w-[70%] md:w-[85%] lg:w-[65%] grid grid-cols-3 gap-x-12 lg:gap-x-24 gap-y-12' >
          {
            team.map((member, index)=>{
              return(
                <div className='col-span-3 md:col-span-1' key={index} >
                  <div className='bg-image-bg2 h-[80%] md:h-[70%] flex justify-end items-end bg-cover bg-center' >
                      <img className='!h-full object-contain object-bottom self-end' src={member.image} alt="" />
                  </div>
                  <div className='flex flex-col items-end' >
                    <h3  data-aos="fade-right" data-aos-duration="800" className='text-xl md:text-lg lg:text-xl font-mosk600' >{member.role}</h3>
                    <hr  data-aos="fade-right" data-aos-duration="900" className='w-[70%] border-2' />
                    <p  data-aos="fade-right" data-aos-duration="1000" className='text-lg' >{member.name}</p>
                  </div>
                </div>
              )
            })
          }
        </div>

        <div className='w-[70%] md:w-[85%] lg:w-[65%] grid grid-cols-3 gap-x-12 lg:gap-x-24 gap-y-12' >
          {
            partner.map((member, index)=>{
              return(
                <div className='col-span-3 md:col-span-1' key={index} >
                  {
                    member.isLogo ? 
                    <div className=' h-[80%] md:h-[70%] flex justify-end items-center bg-cover bg-center' >
                        <img className='!h-full object-contain object-bottom self-end pb-6' src={member.image} alt="" />
                    </div>
                    :

                    <div className='bg-image-bg2 h-[80%] md:h-[70%] flex justify-end items-center bg-cover bg-center' >
                        <img className='!h-full object-contain object-bottom self-end' src={member.image} alt="" />
                    </div>

                  }
                  <div className='flex flex-col items-end' >
                    <h3 data-aos="fade-right" data-aos-duration="800" className='text-xl md:text-lg lg:text-xl font-mosk600' >{member.role}</h3>
                    <hr data-aos="fade-right" data-aos-duration="900" className='w-[70%] border-[#b5b3b3] border-2' />
                    <p data-aos="fade-right" data-aos-duration="1000" className='text-lg' >{member.name}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
    </div>
  )
}

export default Team
